<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="batchPopup()"
          >新增填报</el-button
        >
        <RemoveButton
          type="info"
          :size="$store.state.buttonSize"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
          >批量删除</RemoveButton
        >
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.buttonSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="controlPointName" label="控制点名称"> </el-table-column>
      <el-table-column prop="manager" label="负责人"> </el-table-column>
      <el-table-column prop="productionDate" label="开始日期">
        <template slot-scope="scope">
          {{ scope.row.startDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="endDate" label="结束日期">
        <template slot-scope="scope">
          {{ scope.row.endDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="isQualified" label="监测结论">
        <template slot-scope="scope">
          <template v-if="scope.row.isQualified === 1">
            <el-tag type="success">合格</el-tag>
          </template>
          <template v-else>
            <el-tag type="danger">不合格</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="batchPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="batchDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 弹出层 -->
    <el-dialog
      :close-on-click-modal="false"
      :append-to-body="true"
      :title="title"
      :visible.sync="controlpointFormVisible"
      center
      width="50%"
    >
      <el-form
        :model="controlpointForm"
        :size="$store.state.buttonSize"
        :rules="controlpointFormRules"
        ref="refcontrolpointForm"
        label-width="160px"
      >
        <el-form-item label="关键控制点名称：" prop="controlPointId">
          <el-select
            v-model="controlpointForm.controlPointId"
            style="width:100%;"
            placeholder="请选择关键控制点"
          >
            <el-option
              v-for="item in controlpointList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监测结论：" prop="isQualified">
          <el-select
            v-model="controlpointForm.isQualified"
            style="width:100%;"
            placeholder="请选择监测结论"
          >
            <el-option
              v-for="item in isQualifiedList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人：" prop="manager">
          <el-input
            v-model="controlpointForm.manager"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始日期：" prop="startDate">
          <el-date-picker
            v-model="controlpointForm.startDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            :placeholder="controlpointForm.startDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" prop="endDate">
          <el-date-picker
            v-model="controlpointForm.endDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            :placeholder="controlpointForm.endDate"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="text-center">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceSubmit"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getBatchControlpointList,
  delBatchControlpointList,
  deleteBatchControlpointDel,
  postBatchControlpointEdit,
  putBatchControlpointAdd,
  getBatchControlpointDetail,
  getControlpointList
} from '@/api/batchmanage'

const createForm = () => ({
  // *开始/结束日期
  startDate: '',
  endDate: '',
  // *控制点列表
  controlPointId: null,
  // *负责人
  manager: '',
  // *批次ID
  batchId: null,
  // *监测结论:选择- 1：合格；0：不合格
  isQualified: 1
})

export default {
  data() {
    return {
      selectionID: [],
      controlpointList: [],
      controlpointFormVisible: false,
      isDisabled: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      currentID: null,
      loading: true,
      tableData: [],
      controlpointForm: createForm(),
      isQualifiedList: [{
        id: 0,
        value: 0,
        label: '不合格'
      }, {
        id: 1,
        value: 1,
        label: '合格'
      }],
      controlpointFormRules: {
        startDate: [
          { required: true, message: '请选择生产开始日期', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '请选择生产结束日期', trigger: 'blur' }
        ],
        controlPointId: [
          { required: true, message: '请选择控制点', trigger: 'blur' }
        ],
        isQualified: [
          { required: true, message: '请选择监测结论', trigger: 'blur' }
        ],
        manager: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    batchId: Number,
    productId: Number
  },
  watch: {
    prop(batchId, productId) {
      console.log(batchId)
      console.log(productId)
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑控制点填报' : '新增控制点填报'
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)
    this.debounceSubmit = debounce(300, this.batchSubmit)
    console.log(this.batchId)
    this.getBatchmanageListData()
    this.getControlpointData()
  },
  methods: {
    hanleResetFormVals() {
      this.$set(this, 'controlpointForm', createForm())
      this.$refs.refcontrolpointForm.clearValidate()
      this.controlpointFormVisible = false
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delBatchControlpointList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getBatchmanageListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getBatchmanageListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getBatchmanageListData()
    },
    // 删除控制点
    batchDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteBatchControlpointDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除控制点成功')
              this.getBatchmanageListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 提交表单
    batchSubmit() {
      this.$refs.refcontrolpointForm.validate(valid => {
        if (!valid) return false
        const batchItems = this.currentID
          ? postBatchControlpointEdit
          : putBatchControlpointAdd
        batchItems({
          isQualified: this.controlpointForm.isQualified,
          manager: this.controlpointForm.manager,
          startDate: this.controlpointForm.startDate,
          endDate: this.controlpointForm.endDate,
          controlPointId: this.controlpointForm.controlPointId,
          batchId: this.batchId,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑控制点成功') : this.$message.success('新增控制点成功')
            this.getBatchmanageListData()
            this.controlpointFormVisible = false
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开表单层
    batchPopup(id) {
      this.$set(this, 'controlpointForm', createForm())
      const isAdd = !id
      this.controlpointFormVisible = true
      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        getBatchControlpointDetail(id).then(res => {
          if (res.status === 1) {
            this.currentID = id
            this.controlpointForm.isQualified = res.data.isQualified
            this.controlpointForm.manager = res.data.manager
            this.controlpointForm.startDate = moment(res.data.startDate).format('YYYY-MM-DD')
            this.controlpointForm.endDate = moment(res.data.endDate).format('YYYY-MM-DD')
            this.controlpointForm.controlPointId = res.data.controlPointId
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getBatchmanageListData()
    },
    // 刷新数据表格
    refresh() {
      this.getBatchmanageListData()
      this.$message.success('数据刷新成功')
    },
    // 获取控制点列表
    getBatchmanageListData() {
      console.log(this.batchId)
      this.loading = true
      getBatchControlpointList({
        page: this.page,
        size: this.size,
        batchId: this.batchId
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    },
    // 获取产品关键控制点列表
    getControlpointData() {
      getControlpointList({
        page: 1,
        size: 1000,
        productId: this.productId
      }).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({ label: res.data.rows[i].pointName, value: res.data.rows[i].id, barcode: res.data.rows[i].barcode })
          }
          this.controlpointList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
